<template>
    <ConfirmDialog />
    <Toast />
</template>

<script>
import { useConfirm } from "primevue/useconfirm"
import router from '@/router'
import { useI18n } from 'vue-i18n'

// import { useToast } from "primevue/usetoast"
export default {
  unmounted() {
    this.emitter.off('confirm', this.confirm)
  },
  mounted() {
    this.emitter.on('confirm', this.confirm)
  },
  setup() {
    const c = useConfirm()
    const { t } = useI18n()

    // const toast = useToast()
    // pi pi-info-circle
    // pi pi-exclamation-triangle
    const confirm = (param) => {
      const page = param.page
      c.require({
        message: param.message,
        header: param.header,
        icon: param.icon,
        rejectProps: {
          label: t('menu.cancel'),
          severity: 'secondary',
          outlined: true,
        },
        acceptProps: {
          label: t('menu.confirm')
        },
        accept: () => {
          if(page !== undefined) router.push({name:page})
        },
        // reject: () => {
        //     toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
        // }
      })
    }
    return {
      confirm
    }
  }
}
</script>
